<app-loader *ngIf="savingData" [message]="loadingMessage" @fadeIn></app-loader>
<div
  [ngStyle]="{ 'text-align': buttonPosition }"
  class="button-div"
  *ngIf="!savingData && !showConfirm && !showCancelConfirm"
  @fadeIn
>
  <button
    @fadeIn
    *ngIf="showCancel"
    [disabled]="cancelDisabled"
    class="zoom-on-hover items-center btn-sm text-white"
    mat-stroked-button
    color="warn"
    style="
      margin-right: 10px;
      border-radius: 5px;
      margin-top: 10px;
      padding: 5px 25px;
      font-size: 15px;
    "
    (click)="onClose(true)"
  >
    <mat-icon inline>close</mat-icon>
    {{ cancelText }}
  </button>

  <button
    @fadeIn
    *ngIf="!hideSave"
    [disabled]="saveDisabled"
    [type]="isSubmit && !confirmFirst ? 'submit' : 'button'"
    class="zoom-on-hover items-center btn-sm text-white"
    mat-flat-button
    color="{{saveColor}}"
    style="
      border-radius: 5px;
      margin-top: 10px;
      padding: 5px 25px;
      font-size: 15px;
    "
    (click)="onSave(true)"
  >
    <mat-icon>{{ saveIcon }}</mat-icon>
    {{ saveText }}
  </button>
  <!--<p class="text-right">Your About Save Data, Confirm</p>-->
</div>

<div style="text-align: center" *ngIf="showConfirm" @fadeIn>
  <div class="">
    <p class="lead">{{ confirmText }}</p>
    <p class="confirm-div">
      <button
        [type]="isSubmit && confirmFirst ? 'submit' : 'button'"
        mat-raised-button
        class="yes-button zoom-on-hover"
        @fadeIn
        (click)="isSubmit && confirmFirst ? null : onSave(false)"
      >
        <mat-icon>done</mat-icon> Yes
      </button>
      <button
        mat-raised-button
        class="no-button zoom-on-hover"
        @fadeIn
        (click)="onCancelShowConfirm()"
      >
        <mat-icon>clear</mat-icon> No
      </button>
      &nbsp;
    </p>
  </div>
</div>

<div style="text-align: center" *ngIf="showCancelConfirm" @fadeIn>
  <div class="">
    <p class="lead">{{ cancelConfirmText }}</p>
    <p class="confirm-div">
      <button
        [type]="isSubmit && cancelConfirmFirst ? 'submit' : 'button'"
        mat-raised-button
        class="yes-button zoom-on-hover"
        @fadeIn
        (click)="isSubmit && cancelConfirmFirst ? null : onClose(false)"
      >
        <mat-icon>done</mat-icon> Yes
      </button>
      <button
        mat-raised-button
        class="no-button zoom-on-hover"
        @fadeIn
        (click)="onCancelShowCancelConfirm()"
      >
        <mat-icon>clear</mat-icon> No
      </button>
      &nbsp;
    </p>
  </div>
</div>
